import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../../_hooks/useClientId';

interface AkoyaAccountDTO {
  FinancialInstitution: string;
  Name: string;
  AkoyaTokenId: number;
}

export interface AkoyaDTO {
  Accounts: AkoyaAccountDTO[];
}

const fetchAkoyaAccounts = async (clientId: number): Promise<AkoyaDTO> =>
  authFetch(
    urlWithParams('/Consumer/AkoyaAccounts', {
      clientId,
    }),
  );

export const useAkoyaAccountsQuery = () => {
  const clientId = useClientId();

  return useQuery(queryKeys.akoyaAccounts(clientId), () => fetchAkoyaAccounts(clientId), {
    cacheTime: 0,
  });
};
